import 'whatwg-fetch'

const FETCH_TIMEOUT = 2 * 60 * 1000
const statusText = 'Request timed out'
export default (url, options) => new Promise((resolve, reject) => {
  const timeout = setTimeout(() => reject({statusText, url}), FETCH_TIMEOUT)
  const done = response => clearTimeout(timeout) || resolve(response)
  fetch(url, options).then(done, reject).catch(reject)
})